module.exports = __webpack_public_path__ + "r-v3/img/ml_32_00.31932c91.jpg";